import { jsxs, jsx } from "react/jsx-runtime";
import "../../../constants/index.js";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import { useCallback } from "react";
const BottomNavigationAction = ({
  classes,
  icon,
  active,
  variant = "normal",
  href,
  label,
  className,
  onClick,
  ["aria-label"]: ariaLabel
}) => {
  const { themeClasses } = useThemePresetClasses("BottomNavigationAction", classes, className, {
    variant: variant + (active ? ":active" : "")
  });
  const handleClick = useCallback(() => {
    onClick == null ? void 0 : onClick(href);
  }, [onClick, href]);
  return /* @__PURE__ */ jsxs(
    "button",
    {
      onClick: handleClick,
      className: cn("relative flex h-full flex-col items-center justify-end", themeClasses == null ? void 0 : themeClasses.root, className, {
        "bg-bottomNavBtnIndicatorActive": active
      }),
      "aria-label": ariaLabel,
      children: [
        icon,
        /* @__PURE__ */ jsx(
          "span",
          {
            className: cn("", themeClasses == null ? void 0 : themeClasses.label),
            "aria-label": ariaLabel,
            children: label
          }
        ),
        /* @__PURE__ */ jsx("div", { className: cn("absolute bottom-0 left-1/2 w-[24px] -translate-x-1/2 rounded-t", themeClasses == null ? void 0 : themeClasses.indicator) })
      ]
    }
  );
};
const BottomNavigationAction$1 = BottomNavigationAction;
export {
  BottomNavigationAction$1 as default
};
